import React, { useEffect, useState } from "react";
import { Modal, Button, Container, Card, Col } from "react-bootstrap";
import FormCard from "../common/formCard";
import { FaTimes } from "react-icons/fa";
import { useTranslation } from 'react-i18next';
import MessagePopUp from "../common/messagePopUp";


const PopUpCategoryResponsiblesManage = ({ customKey, show, handleClose, onClickButton, tableData, data, categoriesOptions, workplacesOptions, responsibleOptions, companyId }) => {
  const [t] = useTranslation("companies")
  const [error, setError] = useState(false)
  const [responsibleId, setResponsibleId] = useState(data ? data.responsibleId : null)
  const [categoryId, setCategoryId] = useState(data ? data.incidentCategoryId : null)
  const [workplaceId, setWorkplaceId] = useState(data ? data.workplace : null)
  const [changedResponsible, setChangedResponsible] = useState(false)
  const [enabledButton, setEnabledButton] = useState(false)
  const [showPopupContinue, setShowPopupContinue] = useState(false);
  const [canSubmit, setCanSubmit] = useState(false);
  const originalCategoryId = data?.incidentCategoryId || null;
  const originalResponsibleId = data?.responsibleId || null;


  const handleClick = () => {
    const isEditing = !!data;
    const hasWorkplaceChanged = isEditing && workplaceId !== data.workplace;

    // Verificar si ya existe una entrada con la misma categoría y workplace
    const existingCategory = tableData?.some(entry =>
      entry.incidentCategoryId === categoryId &&
      entry.workplace === workplaceId &&
      entry.categoryResponsibleId !== data?.categoryResponsibleId
    );

    // Si está editando y no ha cambiado el workplace, no hacer verificación
    if (isEditing && !hasWorkplaceChanged) {
      setCanSubmit(true);
      handleContinue();
      return;
    }

    if (existingCategory) {
      // Mostrar alerta si se intenta ingresar una categoría duplicada (con o sin workplace)
      setShowPopupContinue(true);
      setCanSubmit(false);
      return;
    }

    // Si no hay conflictos, permitir la continuación
    setCanSubmit(true);
    handleContinue();
  };


  const handleChangeCategoryId = (value) => {
    setCategoryId(value);
    checkIfButtonShouldBeEnabled(value, responsibleId);
  };

  const handleChangeWorkplaceId = (value) => {
    setWorkplaceId(value);
    setEnabledButton(true);
  };

  const handleChangeResponsibleId = (value) => {
    setChangedResponsible(true);
    setResponsibleId(value);
    checkIfButtonShouldBeEnabled(categoryId, value);
  }

  const handleCloseResetStates = () => {
    handleClose();
    setError(false);
    setEnabledButton(false);
    setCanSubmit(false);
  }

  const handleContinuePopUp = () => {
    setShowPopupContinue(false);

  };

  const handleContinue = () => {
    if (categoryId && responsibleId) {

      const selectedCategory = categoriesOptions.find(category => category.value === categoryId);
      let categoryGroup = selectedCategory ? selectedCategory.categoryGroup : null;
      onClickButton(
        data ? data.categoryResponsibleId : null,
        workplaceId,
        categoryId,
        responsibleId,
        categoryGroup,
        companyId,
        changedResponsible,
      );

      handleCloseResetStates();
    } else {
      setError(true);
    }
  };

  const checkIfButtonShouldBeEnabled = (newCategoryId, newResponsibleId) => {
    if (!data) {
      // Si no hay datos previos, ambos campos deben estar establecidos
      if (newCategoryId !== null && newResponsibleId !== null) {
        setEnabledButton(true);
      } else {
        setEnabledButton(false);
      }
    } else {
      // Si hay datos previos, basta con que uno cambie
      if (
        (newCategoryId !== originalCategoryId && newCategoryId !== null) ||
        (newResponsibleId !== originalResponsibleId && newResponsibleId !== null)
      ) {
        setEnabledButton(true);
      } else {
        setEnabledButton(false);
      }
    }
  };



  useEffect(() => {
    setCategoryId(data ? data.incidentCategoryId : null)
    setWorkplaceId(data ? data.workplace : null)
    setResponsibleId(data ? data.responsibleId : null)
  }, [data]);



  useEffect(() => {
    setResponsibleId(data ? data.responsibleId : null);
    setCategoryId(data ? data.incidentCategoryId : null);
    setWorkplaceId(data ? data.workplace : null);
    setError(false);
    setChangedResponsible(false);
    setEnabledButton(false);
    setCanSubmit(false);
  }, [customKey, data, categoriesOptions, workplacesOptions]);


  return (
    <>
      <MessagePopUp
        show={showPopupContinue}
        handleClose={handleContinuePopUp}
        title={`${t("categoryResponsiblesErrrorPopUp.title")}`}
        textBody={`${t("categoryResponsiblesErrrorPopUp.text")}`}
        buttonText={`${t("companiesPopup.acceptButton")}`}
        onClickButton={handleContinuePopUp}
      />
      <Modal
        show={show}
        onHide={handleClose}
        backdrop="static"
      >
        <Modal.Body className="popup-after-action-modal-body">
          <Container>
            <Card className="mx-auto p-3 rounded-border-px custom-shadow">
              <Card.Body className="d-flex flex-column align-items-center">
                <p className="modal-title mt-2">{data ? `${t("categoryResponsiblesPopUp.edit")}` : `${t("categoryResponsiblesPopUp.create")}`} {t("categoryResponsiblesPopUp.categoryResponsible")}</p>
                <div className="text-center mt-auto w-100">
                  <Button
                    variant="none"
                    className="modal-close-button"
                    onClick={handleCloseResetStates}
                  >
                    <FaTimes className="mb-1" />
                  </Button>
                  <Col md={12}>
                    {data && data.incidentCategoryId ?
                      <FormCard
                        title={t("categoryResponsiblesPopUp.category")}
                        type={"text"}
                        centered
                        text={data?.categoryName}
                        readOnly
                      />
                      :
                      <FormCard
                        title={t("categoryResponsiblesPopUp.category")}
                        type={"select"}
                        options={categoriesOptions}
                        onChange={(e) =>
                          handleChangeCategoryId(e.value)
                        }
                      />
                    }
                  </Col>
                  {workplacesOptions?.length > 0 &&
                    (<Col md={12}>
                      {data && data.workplace ?
                        <FormCard
                          title={t("categoryResponsiblesPopUp.workplace")}
                          type={"select"}
                          selectedValue={{
                            label: data.workplaceName,
                            value: data.workplace,
                          }}
                          options={workplacesOptions}
                          onChange={(e) =>
                            handleChangeWorkplaceId(e.value)
                          }
                        />
                        :
                        <FormCard
                          title={t("categoryResponsiblesPopUp.workplace")}
                          type={"select"}
                          options={workplacesOptions}
                          onChange={(e) =>
                            handleChangeWorkplaceId(e.value)
                          }
                        />
                      }
                    </Col>
                    )}
                  <Col md={12}>
                    {data && data.responsibleId ?
                      <FormCard
                        title={t("categoryResponsiblesPopUp.responsible")}
                        type={"select"}
                        selectedValue={{
                          label: data.responsibleFullNameNIF,
                          value: data.responsibleId,
                        }}
                        options={responsibleOptions}
                        onChange={(e) =>
                          handleChangeResponsibleId(e.value)
                        }
                      />
                      :
                      <FormCard
                        title={t("categoryResponsiblesPopUp.responsible")}
                        type={"select"}
                        options={responsibleOptions}
                        onChange={(e) =>
                          handleChangeResponsibleId(e.value)
                        }
                      />
                    }
                  </Col>


                  <Button
                    type="submit"
                    className="w-25 mx-auto mt-4 custom-button-primary custom-bg-primary"
                    onClick={handleClick}
                    disabled={!enabledButton}
                  >
                    {data ? `${t("categoryResponsiblesPopUp.save")}` : `${t("categoryResponsiblesPopUp.createButton")}`}
                  </Button>
                </div>
              </Card.Body>
            </Card>
          </Container>
        </Modal.Body>
      </Modal >
    </>
  );
};

export default PopUpCategoryResponsiblesManage;